import { render, staticRenderFns } from "./AppbarBordered.vue?vue&type=template&id=76c28bd7&scoped=true"
import script from "./AppbarBordered.vue?vue&type=script&lang=js"
export * from "./AppbarBordered.vue?vue&type=script&lang=js"
import style0 from "./AppbarBordered.vue?vue&type=style&index=0&id=76c28bd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c28bd7",
  null
  
)

export default component.exports